"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommitteeService = void 0;
var Committee_json_1 = __importDefault(require("@orbs-network/orbs-ethereum-contracts-v2/build/contracts/Committee.json"));
var mainnetAddresses_1 = require("../mainnetAddresses");
var MAIN_NET_COMMITTEE_CONTRACT_ADDRESS = mainnetAddresses_1.ORBS_MAIN_NET_CONTRACT_ADDRESSES.committeeService;
var CommitteeService = /** @class */ (function () {
    function CommitteeService(web3, delegationsContractAddress) {
        if (delegationsContractAddress === void 0) { delegationsContractAddress = MAIN_NET_COMMITTEE_CONTRACT_ADDRESS; }
        this.web3 = web3;
        this.committeeContract = new this.web3.eth.Contract(Committee_json_1.default.abi, delegationsContractAddress);
    }
    return CommitteeService;
}());
exports.CommitteeService = CommitteeService;
//# sourceMappingURL=CommitteeService.js.map